export default __webpack_public_path__ + "static/media/include_11@2x.436d203c.jpg";